<template>
	<div class="DashboardCustomers">
		<div class="DashboardCustomers-Headers is-flex is-flex-direction-row-reverse pr-0 is-align-items-center">
			<i 
				class="fas ml-2" 
				:class="`fa-arrow-${sortOrder === 'desc' ? 'down' : 'up'}`"
				@click="handleSortOrderClick" 
			/>

			<select class="select mr-0 pr-0" @change="handleSortSelection">
				<option value="name">{{ $t('dashboard_customers.sort.name') }}</option>
				<option value="childDepartments">{{ $t('dashboard_customers.sort.departments') }}</option>
				<option value="buildings">{{ $t('dashboard_customers.sort.buildings') }}</option>
				<option value="flaws">{{ $t('dashboard_customers.sort.flaws') }}</option>
			</select>

			<label 
				class="is-size-7" 
				style="line-height: 2rem; margin-right: .6rem;"
			>
				{{ $t('dashboard_customers.sort.label') }}
			</label>
		</div>

		<div class="DashboardCustomers-Customer" v-for="customer in departments" :key="customer.id" @click="setActive(customer)">
			<div class="dashboard-table__row">
				<div class="table-row__name-column">
					<p>
						{{ customer.name }}
					</p>
				</div>

				<div class="table-row__information-column">
					<p class="is-size-7">
						{{ customer.flaws }} {{ $t('dashboard_customers.flaws_label') }}
					</p>
					<p class="is-size-7">
						{{ customer.buildings }} {{ $t('dashboard_customers.buildings_label') }}
					</p>
					<p class="is-size-7">
						{{ customer.childDepartments }} {{ $t('dashboard_customers.departments_label') }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	props: {
		customerInformation: {
			type: Object
		}
	},

	data: () => ({
		sort: 'name',
		sortOrder: 'asc'
	}),
	
	computed: {
		departments() {
			return this.sortBy(
				this.customerInformation.departments, 
				`${this.sort}${this.sortOrder === 'desc' ? ' desc' : ''}`);
		}
	},

	methods: {
		...mapActions('user', ['setActiveCustomer']),

		setActive(customer) {
			this.setActiveCustomer({ id: customer.id, parentId: customer?.parentId });
		},

		handleSortSelection(e) {
			const column = e.target.value.trim();
			
			if (this.sort === column)
				this.sortOrder = 'desc';
			else
				this.sortOrder = 'asc';

			this.sort = column;
		},

		handleSortOrderClick() {
			this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
		}
	}
};
</script>

<style lang="scss">
.DashboardCustomers {

}
.DashboardCustomers-Headers {
	padding: 10px;
	margin-bottom: 1rem;

	i {
		pointer-events: unset !important;

		&:hover {
			cursor: pointer !important;
		}
	}
}
.DashboardCustomers-Customer {
	cursor: pointer;
	padding: 10px;
	border-radius: 4px;
	background-color: #4d535d;
	margin-bottom: 10px;

	transition: background-color 0.3s ease;
	box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;

	&:hover {
		transition: background-color 0.3s ease;
		background-color: lighten(#4d535d, 10%);
	}
}

.column-header {
	word-break: break-all;

	&:hover {
		cursor: pointer;
	}
}
</style>
